import { observer } from "mobx-react-lite";
import { Fragment } from "react";
import { Button, Form, Input, Modal, Space } from "antd";
import { UserAccountStore, UserGroupStore } from "../../../store";

function UpdateOrAdd() {
  const form = Form.useFormInstance();

  const getFormData = (changeValue: any, allValues: any) => {
    allValues.no = UserAccountStore.lookPower.no;
    UserAccountStore.setLookPower({ ...allValues, ...changeValue });
  };
  const submitPower = () => {
    if (UserAccountStore.lookPower.displayName) {
      if (UserAccountStore.addOrUpdateModal.update) {
        UserGroupStore.editUserGroup(UserAccountStore.lookPower);
      } else {
        UserGroupStore.saveUserGroup(UserAccountStore.lookPower);
      }
      UserAccountStore.addOrUpdateModal.close();
    }
  };

  return (
    <Fragment>
      <Modal
        width={520}
        centered
        title={UserAccountStore.addOrUpdateModal.update ? "编辑" : "新增"}
        open={UserAccountStore.addOrUpdateModal.isOpen}
        destroyOnClose={true}
        onCancel={() => UserAccountStore.addOrUpdateModal.close()}
        footer={null}
      >
        {
          <Form
            form={form}
            labelCol={{ flex: "110px" }}
            labelWrap
            initialValues={UserAccountStore.lookPower}
            wrapperCol={{ flex: 1 }}
            onValuesChange={getFormData}
            style={{marginTop:'20px'}}
          >
            <Form.Item
              label="用户组名称"
              name="displayName"
              rules={[{ required: true, message: "请输入账户名称" }]}
            >
              <Input placeholder="请输入用户组名称" style={{ width: "330px" }}  size='middle' maxLength={50} showCount/>
            </Form.Item>
            <Form.Item
              label="备注"
              name="description"
            >
              <Input style={{ width: "330px" }}  showCount maxLength={100} />
            </Form.Item>
            <Form.Item
              style={{ textAlign: "right" }}
              wrapperCol={{ span: 18, offset: 6 }}
            >
              <Space>
                <Button
                  htmlType="reset"
                  onClick={() => UserAccountStore.addOrUpdateModal.close()}
                >
                  取消
                </Button>
                <Button type="primary" htmlType="submit" onClick={submitPower}>
                  确定
                </Button>
              </Space>
            </Form.Item>
          </Form>
        }
      </Modal>
    </Fragment>
  );
}

export default observer(UpdateOrAdd);
